

/*====== import  ======*/
/*------ React ------*/
import React, { useEffect } from "react"
/*------ CSS ------*/
// import styled from 'styled-components';
/*------ Component Js/Jsx ------*/
import { LoadingProgressBar } from "02CommonUiParts/OtherParts/LoadingProgressBar";
import { cognitoAuthenticateURL } from "03CommonApiParts/authConfig";
/*====== Styles  ======*/
/*------ Styled Components ------*/

/*====== global variables ======*/

/*====== global functions ======*/

/* --------------------------- */
/* ---------- main ---------- */
/* --------------------------- */
export const AUTHCA = () =>{ //cognitoリダイレクト処理
    
    /* --------------------------- */
    /* -------- instance  -------- */
    /* --------------------------- */

    /* --------------------------- */
    /* ---------- state ---------- */
    /* --------------------------- */

    /* --------------------------- */
    /* -------- variables -------- */
    /* --------------------------- */

    /* --------------------------- */
    /* -------- functions -------- */
    /* --------------------------- */
    useEffect(()=>{
        redirect();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);
    
    /* cognito認証用 */
    const redirect = () =>{
        window.top.location = cognitoAuthenticateURL;
    };
    /* --------------------------- */
    /* ---------- data ----------- */
    /* --------------------------- */

    return(
        <>
            <LoadingProgressBar open={true}/>
        </>
    );
}

